<template>
    <iframe
            :src="botUrl"
            style="height: 100%; width: 100%;"></iframe>
</template>

<script>

export default {
  name: 'botIframe',
  props: {
    botUrl: {
      type: String
      // default: config.botUrlPrefix + '15967885091466566'
    }
  }
}
</script>

<style scoped lang="less">
    @media screen and(max-width: 766px) {
        iframe {
            width: 100% !important;
            height: calc(100vh - 65px - 72px) !important;
        }
    }

    iframe {
        border: none;
        width: 100%;
        height: 100%;

        /deep/ .whole {
            height: 100% !important;
        }
    }
</style>
